import moment from "moment";

export const gettingFilteredSubsidiariesByUserAccess = (
  user,
  subsidiaries,
  subsidiary
) => {
  if (user?.email === "lumarketo.desarrollo@gmail.com") {
    return subsidiaries;
  } else {
    if (user?.subsidiaries?.length === 1 && user?.subsidiaries[0] === "all") {
      return subsidiaries;
    } else if (subsidiary.includes("all")) {
      return subsidiaries.filter((item) =>
        user?.subsidiaries?.includes(item._id)
      );
    } else {
      return subsidiaries.filter((subsidiarySelected) =>
        subsidiarySelected._id?.includes(subsidiary)
      );
    }
  }
};

export const getSubsidiariesForUser = (
    user,
    allSubsidiaries,
) => {
    // 1. Immediate Guard Clause
    if (!user) return [];

    // 2. Normalize inputs: Remove the "all" placeholder immediately
    // This allows us to work with clean data for the rest of the function
    const cleanSubsidiaries = allSubsidiaries.filter(s => s._id !== 'all');

    // 3. Define Admin/Superuser logic
    // Replace the email check with a role check if possible, or keep it isolated here
    const isSuperAdmin = user.email === "lumarketo.desarrollo@gmail.com";
    const hasGlobalAccess = user.subsidiaries?.some(s => s === "all");

    // 4. If Admin or Global Access, return everything (optionally filtered by target)
    if (isSuperAdmin || hasGlobalAccess) {
        return cleanSubsidiaries;
    }

    // 5. Calculate User Permissions
    // Create a Set of IDs for O(1) lookup performance instead of .some() O(n)
    const userAllowedIds = new Set(user.subsidiaries?.map(s => s));

    // 6. Base Access: Filter the main list to ONLY what the user owns
    const userAccessibleSubsidiaries = cleanSubsidiaries.filter(item =>
        userAllowedIds.has(item._id)
    );


    // 8. Default: Return what the user owns
    return userAccessibleSubsidiaries;
};

export const checkSubsidiaryAutomaticAcceptanceStatus = (subsidiaries) => {
  return subsidiaries.some((subsidiary) => subsidiary.UseAutoOrderAcceptance);
};

export const checkIfSubsidiaryIsInWorkingHours = () => {
  const chileCurrentTime = moment().tz("America/Santiago");

  const nineAM = moment
    .tz("America/Santiago")
    .set({ hour: 9, minute: 0, second: 0, millisecond: 0 });
  const twelveAM = moment
    .tz("America/Santiago")
    .add(1, "day")
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

  const isAfterNineAM = chileCurrentTime.isAfter(nineAM);
  const isBeforeTwelveAM = chileCurrentTime.isBefore(twelveAM);

  return isAfterNineAM && isBeforeTwelveAM;
};

const subsidiariesFunctions = {
  gettingFilteredSubsidiariesByUserAccess,
  checkSubsidiaryAutomaticAcceptanceStatus,
  checkIfSubsidiaryIsInWorkingHours,
  getSubsidiariesForUser
};
export default subsidiariesFunctions;
